'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _trvFedModulesI18n = require('../trv-fed-modules-i18n');

var _trvFedModulesI18n2 = _interopRequireDefault(_trvFedModulesI18n);

var _trvFedModulesUrls = require('../trv-fed-modules-urls');

var _trvFedModulesUrls2 = _interopRequireDefault(_trvFedModulesUrls);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _banner = require('./banner');

var _banner2 = _interopRequireDefault(_banner);

var _breadcrumbs = require('./breadcrumbs');

var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);

var _currencies = require('./currencies');

var _currencies2 = _interopRequireDefault(_currencies);

var _domains = require('./domains');

var _domains2 = _interopRequireDefault(_domains);

var _explanations = require('./explanations');

var _explanations2 = _interopRequireDefault(_explanations);

var _hotelInformation = require('./hotelInformation');

var _hotelInformation2 = _interopRequireDefault(_hotelInformation);

var _hotels = require('./hotels');

var _hotels2 = _interopRequireDefault(_hotels);

var _navigations = require('./navigations');

var _navigations2 = _interopRequireDefault(_navigations);

var _notifications = require('./notifications');

var _notifications2 = _interopRequireDefault(_notifications);

var _recommendations = require('./recommendations');

var _recommendations2 = _interopRequireDefault(_recommendations);

var _rooms = require('./rooms');

var _rooms2 = _interopRequireDefault(_rooms);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _seo = require('./seo');

var _seo2 = _interopRequireDefault(_seo);

var _filters = require('./filters');

var _filters2 = _interopRequireDefault(_filters);

var _signatures = require('./signatures');

var _signatures2 = _interopRequireDefault(_signatures);

var _topDestinations = require('./topDestinations');

var _topDestinations2 = _interopRequireDefault(_topDestinations);

var _features = require('./features');

var _features2 = _interopRequireDefault(_features);

var _language = require('./language');

var _language2 = _interopRequireDefault(_language);

var _page = require('./page');

var _page2 = _interopRequireDefault(_page);

var _exception = require('./exception');

var _exception2 = _interopRequireDefault(_exception);

var _httpRequest = require('./httpRequest');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _pageFocusedField = require('./pageFocusedField');

var _pageFocusedField2 = _interopRequireDefault(_pageFocusedField);

var _searchBox = require('./searchBox');

var _searchBox2 = _interopRequireDefault(_searchBox);

var _galleryViewer = require('./galleryViewer');

var _galleryViewer2 = _interopRequireDefault(_galleryViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  i18n: _trvFedModulesI18n2.default,
  urls: _trvFedModulesUrls2.default,
  banner: _banner2.default,
  breadcrumbs: _breadcrumbs2.default,
  currencies: _currencies2.default,
  domains: _domains2.default,
  explanations: _explanations2.default,
  hotelInformation: _hotelInformation2.default,
  hotels: _hotels2.default,
  navigations: _navigations2.default,
  notifications: _notifications2.default,
  recommendations: _recommendations2.default,
  rooms: _rooms2.default,
  search: _search2.default,
  seo: _seo2.default,
  filters: _filters2.default,
  signatures: _signatures2.default,
  topDestinations: _topDestinations2.default,
  features: _features2.default,
  pageFocusedField: _pageFocusedField2.default,
  searchBox: _searchBox2.default,
  galleryViewer: _galleryViewer2.default,
  // modules
  page: _page2.default,
  exception: _exception2.default,
  auth: _auth2.default,
  language: _language2.default,
  httpRequest: _httpRequest2.default,
  logger: _logger2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/modules/reducer.js
// module id = 1248
// module chunks = 0